import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "./../../utils/Modal";
import Swal from "sweetalert2";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlogList = (props) => {
  const {
    blogs,
    index,
    loadingCallback,
    setSuccessFlashMessage,
    setPayment,
    getBlogList,
    navigate,
  } = props;

  const token = localStorage.getItem("token");
  const [showBlogViewModal, setShowBlogViewModal] = useState(false);
  const [blog, setBlog] = useState("");
  const [showBlogEditModal, setShowBlogEditModal] = useState(false);

  const handleBlogViewOpen = (id, blog) => {
    getBlogView(id);
    setBlog(blog);
  };

  const getBlogView = (id) => {
    setShowBlogViewModal(true);
  };

  const handleBlogEditOpen = (blog) => {
    setBlog(blog);
    setShowBlogEditModal(true);
  };

  const showModalBeforeDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}delete-latest-blog/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          getBlogList();
          notify("Blog deleted successfully", "success");
        }
      })
      .catch((error) => {
        console.error(
          "Error deleting blog:",
          error.response?.data || error.message
        );

        // Handle unauthorized errors (e.g., token expired)
        if (error.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          navigate("/login");
        } else {
          notify("Failed to delete blog. Please try again.", "error");
        }
      });
  };
  const notify = (msg, type) => {
    if (type == "success") {
      toast.success(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 9999 },
      });
    }
    if (type == "error") {
      toast.error(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 9999 },
      });
    }
  };

  return (
    <>
      {console.log(blogs)}
      <div>
        <div
          key={index}
          className="grid grid-cols-5 md:gap-5  gap-2 items-center font-nunito font-[500] text-[14px] text-[#000232] border-t-[1px] border-solid border-[#E7EBF4] py-[8px]"
        >
          {/* <div className="border-t-[1px] border-solid border-[#E7EBF4] py-[8px] font-nunito font-[500] text-[#000232] grid grid-cols-7 items-start"> */}
          <div>
            <div className="">
              {/* <div className="font-nunito text-[14px]"> */}
              <div className="font-[500] text-[#000232]">#{index + 1}</div>
              <div className="font-[700] text-[#87889E]">{blogs.title}</div>
              {/* </div> */}
            </div>
          </div>
          {/* <div className="text-center">{blogs.catogory_name}</div> */}
          <div className="text-center">{blogs.status}</div>
          <div className="text-center">
            {new Date(blogs.created_at).toISOString().split("T")[0]}
          </div>
          <div className="text-center">
            {new Date(blogs.updated_at).toISOString().split("T")[0]}
          </div>
          <div className="flex gap-2  text-xs justify-end">
            <label
              htmlFor="view_blog_modal"
              // onClick={()=>setShowViewModal(val=>!val)}
              //onClick={()=> Swal.fire("View option coming soon")}
              onClick={() => handleBlogViewOpen(blogs?.id, blogs)}
              className="cursor-pointer border-[1px] border-solid border-[#407BFF] text-[#407BFF] rounded-[5px] px-[6px] py-1"
            >
              VIEW
            </label>
            <label
              htmlFor="edit_blog_modal"
              //onClick={()=> Swal.fire("Edit option coming soon")}
              onClick={() => handleBlogEditOpen(blogs)}
              className="cursor-pointer border-[1px] border-solid bg-[#407BFF] border-[#407BFF] text-white rounded-[5px] px-[7px] py-1"
            >
              EDIT
            </label>
            <label
              // htmlFor="editAccTxn_modal"
              // onClick={()=> Swal.fire("Edit option coming soon")}
              onClick={() => showModalBeforeDelete(blogs?.id)}
              className="cursor-pointer border-[1px] border-solid bg-[#FF0303] text-white rounded-[5px] px-[7px] py-1"
            >
              DELETE
            </label>
          </div>
        </div>
      </div>

      {showBlogViewModal ? (
        <Modal
          isOpen={showBlogViewModal}
          setOpen={setShowBlogViewModal}
          //setWarningMessage={setWarningMessage}
          title="Blog Details"
          formId="viewBlogModal"
          loadingCallback={loadingCallback}
          //navigate={navigate}
          type="viewBlogModal"
          blog={blog}
        />
      ) : null}

      {showBlogEditModal ? (
        <Modal
          isOpen={showBlogEditModal}
          setOpen={setShowBlogEditModal}
          //setWarningMessage={setWarningMessage}
          title="Edit Blog"
          formId="edit_blog_modal"
          //loadingCallback={loadingCallback}
          //navigate={navigate}
          type="edit_blog_modal"
          //formData={editFormData}
          //setFormData={setEditFormData}
          blog={blog}
          notify={notify}
          //refetch={()=>setRefetch(val=>!val)}
          getBlogList={getBlogList}
        />
      ) : null}
    </>
  );
};

export default BlogList;
